const STORAGE_PREFIX = "creatorverse.notifications.feature-intro.v1";

export function featureIntroStorageKey(userId?: string | null): string {
	return userId ? `${STORAGE_PREFIX}:${userId}` : STORAGE_PREFIX;
}

export function hasDismissedFeatureIntro(userId?: string | null): boolean {
	try {
		return localStorage.getItem(featureIntroStorageKey(userId)) === "1";
	} catch {
		return false;
	}
}

export function dismissFeatureIntro(userId?: string | null): void {
	try {
		localStorage.setItem(featureIntroStorageKey(userId), "1");
	} catch {
		// Ignore quota / private-mode failures; intro may reappear next session.
	}
}
